import { isMockedData } from "@constants/demo";
import { useAppStore } from "@hooks/useAppStore";

const STAGING_MIXPANEL_TOKEN = process.env.EXPO_PUBLIC_MIXPANEL_TOKEN_STAGING;

const isProduction = process.env.NODE_ENV === "production";
const mixpanelToken = useAppStore.getState().app.analytics.mixpanel.id;
const getTokens = () => {
	if (isProduction && !isMockedData) {
		return {
			mixpanelToken,
		};
	}
	return {
		mixpanelToken: STAGING_MIXPANEL_TOKEN,
	};
};

export { getTokens };
